// FIX ME circular dependency
// eslint-disable-next-line workspaces/require-dependency
import { getSelectDatabaseDraft } from '@databases/fields/utils';
import { useActionWithDependencies } from '@databases/redux';
import { getEntryCover } from '@databases/utils/coverImage';
import useView from '@databases/views/useView';
import React, { type FunctionComponent, useCallback } from 'react';

import CoverImage, { type CoverImageProps } from './CoverImage';

interface EntryCoverImageProps extends Omit<CoverImageProps, 'image'> {
  contentId: string;
  entryId: string;
}

/**
 * Renders the cover image of a database entry. If the database doesn't have a cover field defined, nothing is rendered.
 */
const EntryCoverImage: FunctionComponent<EntryCoverImageProps> = ({
  contentId,
  entryId,
  ...props
}) => {
  const {
    view: { settings: viewSettings },
  } = useView();

  const {
    result: { coverImage, fallback },
  } = useActionWithDependencies(
    useCallback(
      (helpers) => {
        return getEntryCover(
          { contentId, entryId, viewSettings },
          {
            ...helpers,
            selectDatabase: getSelectDatabaseDraft(true),
          }
        );
      },
      [contentId, entryId, viewSettings]
    )
  );

  return (
    <CoverImage
      contentId={contentId}
      width="100%"
      {...props}
      image={coverImage}
      fallback={fallback?.src}
    />
  );
};

export default EntryCoverImage;
